import React, { Component } from "react";
import { connect } from "react-redux";
import Socialmedia from "./PublicProfile";
import { viewLinkByUserName, setTankYou, giveFeedBack } from "../../admin/adminActions";
export class Controller extends Component {
  render() {
    return <Socialmedia {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    viewLinkByUserName: (username) => {
      dispatch(viewLinkByUserName(username));
    },
    giveFeedBack: (username, rating, name, email, mobile, desc) => {
      dispatch(giveFeedBack(username, rating, name, email, mobile, desc));
    },
    setTankYou: (payload) => {
      dispatch(setTankYou(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
